function trackFunction(params) {
  $("footer")
    .attr(
      "data-track",
      '{"type":"click","params":{"version":"4.9.6","cfrom":"01|02|044|001","duration":"' +
        params.duration +
        '","module":"' +
        params.module +
        '"}}'
    )
    .trigger("click")
    .removeAttr("data-track");
}

/**
 * 初始化曝光埋点
 * @param {*} elements
 * @returns
 */
export function initExposureTrack(elements) {
  const durationList = {};
  return function () {
    if (!window.$) return;
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const $this = $(entry.target);
        if (entry.isIntersecting) {
          durationList[$this.data("position")] = +new Date();
        } else {
          const duration = durationList[$this.data("position")];
          if (duration) {
            trackFunction({
              duration: +new Date() - duration,
              module: $(entry.target).data("name"),
            });
          }
        }
      });
    }, {});
    $(elements).each(function () {
      observer.observe($(this)[0]);
    });
  };
}
